import { Type } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';

export class DynamicInputComponent {
  constructor(public component: Type<any>, public data?: any) {
  }
}

export interface MenuGroup {
  title: string;
  menuTag: string;
  menuItems?: NbMenuItem[];
  index?: number;
}
